import { styled, Theme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Button from '@mui/material/Button'

export const LoanStatusContainer = styled(Box)(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '20px',
  color: 'white',
  margin: 'auto',
  fontWeight: 200,
  overflowY: 'auto',
  [theme.breakpoints.down('sm')]: {
    padding: '10px',
  },
}))

export const CardsContainer = styled('div')(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  gap: '20px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}))

export const ShortCardsContainer = styled('div')(({ theme }: { theme: Theme }) => ({
  width: '40%',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}))

export const TallCardStyled = styled(Card)(({ theme }: { theme: Theme }) => ({
  width: '55%',
  background: 'transparent',
  height: '450px',
  borderRadius: '15px',
  padding: '22px',
  border: '1px solid #333',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    height: '450px',
  },
}))

export const ShortCardStyled = styled(Card)(({ theme }: { theme: Theme }) => ({
  background: 'transparent',
  borderRadius: '15px',
  padding: '0x 5px 0px 2px ',
  border: '1px solid #333',
  height: '200px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    height: '220px'
  },
}))
export const LoanButtons = styled(Box)(({ theme }) => ({
  marginLeft: '1rem',
  [theme.breakpoints.down('sm')]: {
    marginLeft: '2rem',
  },
}))

export const ContactButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#E6492D',
  color: 'white',
  padding: '0.7rem 3.7rem',
  borderRadius: '9px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '30%',
  maxWidth: '30%',
  marginTop: '0.9rem',
  gap: '0.5rem',
  border: 'none',
  cursor: 'pointer',
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: '#a93621',
  },
  [theme.breakpoints.down('sm')]: {
    marginLeft: '-1rem',
    minWidth: '100%',
    maxWidth: '100%',
  },
}))
